module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Light.712a219.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Light.woff
// module id = hRwB
// module chunks = 1